export default __webpack_public_path__ + "static/media/pak31.5f1c4b21.jpg";